import React, { useState } from "react";
import { Dialog, IconButton, Grid } from "@mui/material";
import { ArrowBackIos, ArrowForwardIos, Close } from "@mui/icons-material";
import { useSwipeable } from "react-swipeable";

interface ImgGalleryProps {
    imageSrc: string;
    // images?: string[]; // Uncomment this line for multiple images support
}

export const ImgGallery: React.FC<ImgGalleryProps> = ({ imageSrc }) => {
    const [open, setOpen] = useState(false);
    // const [currentIndex, setCurrentIndex] = useState(0); // For multiple images

    // Open dialog
    const handleOpen = () => {
        setOpen(true);
    };

    // Close dialog
    const handleClose = () => {
        setOpen(false);
    };

    // Swipe gesture handlers
    const handlers = useSwipeable({
        onSwipedLeft: handleClose, // Change to nextImage for multiple images
        onSwipedRight: handleClose, // Change to prevImage for multiple images
        preventScrollOnSwipe: true,
        trackMouse: true
    });

    return (
        <>
            {/* Display Single Image */}
            <Grid container>
                <Grid item>
                    <img
                        src={imageSrc}
                        alt="Factory Image"
                        style={{
                            width: "200px",
                            cursor: "pointer",
                            borderRadius: "5px",
                            marginRight: "150px"
                        }}
                        onClick={handleOpen}
                    />
                </Grid>
            </Grid>

            {/* Image Dialog for Preview */}
            <Dialog open={open} onClose={handleClose} maxWidth="md">
                <div {...handlers} style={{ position: "relative" }}>
                    {/* Close Button */}
                    <IconButton
                        style={{
                            position: "absolute",
                            top: 10,
                            right: 10,
                            background: "#0000007a"
                        }}
                        onClick={handleClose}
                    >
                        <Close sx={{ color: "#fff" }} />
                    </IconButton>

                    {/* Display Single Image */}
                    <img
                        src={imageSrc}
                        alt="Preview"
                        style={{ width: "100%", maxHeight: "80vh" }}
                    />
                </div>
            </Dialog>

            {/* 
      ===============================
      Uncomment this section if you need multiple images
      ===============================
      */}

            {/*
      const images = [
        "https://st2.depositphotos.com/1000291/7508/i/450/depositphotos_75088131-stock-photo-metal-working-gear-machining.jpg",
        "https://us.123rf.com/450wm/photoroad/photoroad1301/photoroad130100354/17147496-new-brake-disc.jpg?ver=6",
        "https://img.freepik.com/free-photo/precision-grinding-within-cylindrical-shape_60438-4077.jpg?semt=ais_hybrid",
        "https://gesrepair.com/wp-content/uploads/bigstock-140745698.jpg",
      ];

      // Open with clicked image
      const handleOpen = (index) => {
        setCurrentIndex(index);
        setOpen(true);
      };

      // Navigate images
      const prevImage = () => {
        setCurrentIndex((prevIndex) =>
          prevIndex === 0 ? images.length - 1 : prevIndex - 1
        );
      };

      const nextImage = () => {
        setCurrentIndex((prevIndex) =>
          prevIndex === images.length - 1 ? 0 : prevIndex + 1
        );
      };

      return (
        <>
          <Grid container spacing={2}>
            {images.map((img, index) => (
              <Grid item xs={3} key={index}>
                <img
                  src={img}
                  alt={`Thumbnail ${index + 1}`}
                  style={{
                    width: "100%",
                    cursor: "pointer",
                    borderRadius: "5px",
                    maxHeight: "120px",
                    minHeight: "120px",
                  }}
                  onClick={() => handleOpen(index)}
                />
              </Grid>
            ))}
          </Grid>

          <Dialog open={open} onClose={handleClose} maxWidth="md">
            <div {...handlers} style={{ position: "relative" }}>
              <IconButton
                style={{
                  position: "absolute",
                  top: 10,
                  right: 10,
                  background: "#0000007a",
                }}
                onClick={handleClose}
              >
                <Close sx={{ color: "#fff" }} />
              </IconButton>

              <IconButton
                style={{
                  position: "absolute",
                  top: "50%",
                  left: 10,
                  background: "#0000007a",
                }}
                onClick={prevImage}
              >
                <ArrowBackIos sx={{ color: "#fff", paddingLeft: "5px" }} />
              </IconButton>

              <img
                src={images[currentIndex]}
                alt="Preview"
                style={{ width: "100%", maxHeight: "80vh" }}
              />

              <IconButton
                style={{
                  position: "absolute",
                  top: "50%",
                  right: 10,
                  background: "#0000007a",
                }}
                onClick={nextImage}
              >
                <ArrowForwardIos sx={{ color: "#fff", paddingLeft: "5px" }} />
              </IconButton>
            </div>
          </Dialog>
        </>
      );
      */}
        </>
    );
};
